import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    completeDocumentDescription:
      'We’ll review your application as soon as you send this document',
    fallbackDocumentName: 'Document',
    uploadedDocumentName: 'Document',
    uploadFormDragDrop: 'Drag and drop to upload the completed document',
  },
  fr: {
    completeDocumentDescription:
      'Nous pourrons vérifier votre inscription dès que nous aurons reçu ce document.',
    fallbackDocumentName: 'Document',
    uploadedDocumentName: 'Document',
    uploadFormDragDrop: 'Déposez votre document complété ici',
  },
} as const);
